import { CartFeeSummaryUrl, CartUcinetIdUrl, CoursesUrl, CartUrl, CartSummaryUrl, APIDownError, CartProfileUpdateUrl  } from "../directives/utilities/urls";
export default function cartList() {
    return {
        selectedSubjectFilter: document.getElementById("categoryId")?.value || [],
        showErrorMesage: "",
        showSuccessMesage: "",
        enrollmentCartList: [],
        waitlistCartList: [],
        selectedItem:[],
        hasMore: false,
        message:'',
        showLoader: false,
        categoryId: "",
        nextPageUrl: CartProfileUpdateUrl,
        coursesUrl: CoursesUrl,
        allowRegistration:true,
        formatDate(dateValue) {
            const options = { month: "short", day: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
                undefined,
                options
            );
            return formattedDate;
        },

        showRemoveCartList(item) {
            this.selectedItem = item;
            document.getElementById("btnDelete").click();
        },
        removeCartList() {
                var jsonData = JSON.stringify({
                    "UserSessionId": "",
                    "AcademicYear": this.selectedItem.academicYear,
                    "AcademicTerm": this.selectedItem.academicTerm,
                    "AcademicSession": this.selectedItem.academicSession,
                    "SerialId": this.selectedItem.serialId
                });
                this.showLoader = true;

                fetch("/api/Checkout/delete-course-from-cart", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: jsonData,
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            this.showSuccessMesage = "Course removed succesfully."
                            window.location.href = CartUrl;
                        } else {
                            this.showErrorMesage = APIDownError;
                        }
                    });
           // }

        },
        bindCartList() {
    
            var jsonData = JSON.stringify({
                SessionId: "",
                CartRequestType: "A"
            });
            this.showLoader = true;
            this.waitlistCartList = [];
            this.enrollmentCartList = [];
            fetch("/api/Checkout/cart", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: jsonData,
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {

                        if (response.cartItems.length > 0) {
                            for (var item = 0; item < response.cartItems.length; item++) {
                                if (response.cartItems[item].actionType == "W") {
                                    this.waitlistCartList.push(response.cartItems[item]);
                                } else {
                                    this.enrollmentCartList.push(response.cartItems[item]);
                                }
                                if (this.waitlistCartList.length > 0 && this.enrollmentCartList.length <= 0) {                                    
                                    this.nextPageUrl = CartProfileUpdateUrl;
                                }
                            }
                            this.loadCart();
                            this.showErrorMesage = "";
                        } else {
                            this.showErrorMesage = "Your cart is empty.";
                        }
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },
        loadCart() {
        
            fetch("/api/Checkout/load-cart", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        this.allowRegistration = response.allowRegistration;
                        if (!response.allowRegistration && response.studentOverMaxUnits)
                            this.message = "Your current course schedule/selections(s) exceed the study load limit for the " + response.academicYear + " / " + response.academicTerm + " term.<br/> Maximum allowed is " + response.allowedUnits + " units, you are currently enrolled in " + response.totalUnits + " units.";
                    } else {
                        this.message = response.message;
                    }
                });

        },
        init() {
     
            this.bindCartList();
           
        },
    };
}
